import { useState } from 'react'
import { Play } from 'lucide-react'
import { Spinner } from '@/components/ui'

interface VoicePreviewPlayerProps {
  voiceId: string | null
  voiceName: string | null
  onSynthesize: (voiceId: string, text: string) => Promise<void>
  isSynthesizing: boolean
  supportsPreviewSynthesis: boolean
}

const MAX_CHARS = 200

export function VoicePreviewPlayer({
  voiceId,
  voiceName,
  onSynthesize,
  isSynthesizing,
  supportsPreviewSynthesis,
}: VoicePreviewPlayerProps) {
  const [customText, setCustomText] = useState('Hello, welcome to our service. How can I help you today?')

  if (!supportsPreviewSynthesis) return null

  const handlePreview = async () => {
    if (!voiceId || !customText.trim()) return
    await onSynthesize(voiceId, customText.trim())
  }

  return (
    <div className="flex items-center gap-2 px-4 py-3 border-t border-border bg-muted">
      <span className="text-xs text-muted-foreground shrink-0">Try custom text:</span>
      <input
        type="text"
        value={customText}
        onChange={(e) => setCustomText(e.target.value.slice(0, MAX_CHARS))}
        className="flex-1 bg-background border border-border rounded-md px-3 py-1.5 text-xs text-foreground placeholder:text-muted-foreground focus:outline-hidden focus:border-primary"
        placeholder="Enter text to preview..."
        maxLength={MAX_CHARS}
      />
      <button
        onClick={handlePreview}
        disabled={!voiceId || isSynthesizing || !customText.trim()}
        className="flex items-center gap-1 px-3 py-1.5 bg-muted border border-border rounded-md text-xs text-muted-foreground hover:text-foreground hover:bg-muted-foreground/10 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shrink-0"
        title={voiceId ? `Preview with ${voiceName ?? voiceId}` : 'Play a voice first, then try custom text'}
      >
        {isSynthesizing ? (
          <Spinner className="w-3 h-3" />
        ) : (
          <Play className="w-3 h-3" />
        )}
        Preview
      </button>
    </div>
  )
}
